import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { GenerateTicketModalComponent } from '../../ticketing/generate-ticket-modal/generate-ticket-modal.component';
import { ApiService } from 'src/app/services/api/api.service';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';

@Component({
  selector: 'app-workflow-details',
  standalone: false,
  templateUrl: './workflow-details.component.html',
  styleUrl: './workflow-details.component.scss',
})
export class WorkflowDetailsComponent implements OnInit {
  form: FormGroup;
  approvalForm: FormGroup;
  stages: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { id: any },
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<GenerateTicketModalComponent>,
    private apiService: ApiService,
    private dialog: MatDialog
  ) {
    this.form = this.fb.group({
      workflowName: [''],
      description: [''],
      lga: [''],
    });
  }
  ngOnInit(): void {
    this.getWorkflow();
  }

  getWorkflow(): void {
    this.apiService.get(`/workflow/get/single/${this.data?.id}`).subscribe({
      next: (response: any) => {
        if (response) {
          this.patchForm(response);
        }
      },
      error: (error) => {
        this.openErrorModal(error?.message);
      },
    });
  }

  patchForm(data: any) {
    this.form.patchValue({ workflowName: data?.name });
    this.form.patchValue({ description: data?.description });
    this.form.patchValue({ lga: data?.lga });

    this.stages = data?.stagesDto;
  }

  initApprovalForm(data: any): void {
    this.approvalForm = this.fb.group({
      approverId: [''],
      stageNumber: [''],
      onApproved: [''],
    });
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {});
  }
}
